module.exports = __webpack_public_path__ + "static/media/furia-mission.862ce1bb.svg";